import { forwardRef, useCallback } from 'react';
import { Box } from '@mui/material';
import { useSnackbar, SnackbarContent, CustomContentProps, SnackbarMessage } from 'notistack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import './Loading.scss';

interface LoadingProps extends CustomContentProps {
    message: SnackbarMessage;
}

const Loading = forwardRef<HTMLDivElement, LoadingProps>(({ id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);

    return (
        <SnackbarContent ref={ref}>
            <Card className="snackbar-body">
                <CardActions>
                    <RefreshIcon className="loading-icon" />
                    <Typography variant="body2" className="message-text">
                        {props.message}
                    </Typography>
                    <Box className="button-container">
                        <Button size="small" onClick={handleDismiss} disableRipple={true}>
                            Dismiss
                        </Button>
                    </Box>
                </CardActions>
            </Card>
        </SnackbarContent>
    );
});

Loading.displayName = 'loading';

export default Loading;
